export function computeMissingSequences(sequences: number[]): number[] {
  if (sequences.length === 0) return [];

  const set = new Set(sequences);
  const max = Math.max(...sequences);
  const missing: number[] = [];

  for (let i = 1; i <= max; i++) {
    if (!set.has(i)) missing.push(i);
  }

  return missing;
}

export function getLastMsgSequence(sequences: number[]): number {
  if (sequences.length === 0) return 0;
  return Math.max(...sequences);
}
